import { createTheme } from "@mui/material";

const primaryColors = {
    moderateBlue: "hsl(238, 40%, 52%)",
    softRed: "hsl(358, 79%, 66%)",
    lightGrayishBlue: "hsl(239, 57%, 85%)",
    paleRed: "hsl(357, 100%, 86%)",
  },
  neutralColors = {
    darkBlue: "hsl(212, 24%, 26%)",
    grayishBlue: "hsl(211, 10%, 45%)",
    lightGray: "hsl(223, 19%, 93%)",
    veryLightGray: "hsl(228, 33%, 97%)",
    white: "hsl(0, 0%, 100%)",
  };

export const theme = createTheme({
  palette: {
    primary: {
      main: primaryColors["moderateBlue"],
    },
    secondary: {
      main: neutralColors["darkBlue"],
    },
    error: {
      main: primaryColors["softRed"],
    },
  },
});
